import { TextButton } from '@creditornot/cb-button';
import isEqual from 'lodash/isEqual';
import React from 'react';
import { useFieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';

import { FormOptionValue } from './types';
import { buildNewFormOptionValue } from './utils';

type Props = {
  className?: string;
};

export const AddOptionValueButton = ({ className }: Props) => {
  const { fields } = useFieldArray<FormOptionValue>('values', { isEqual });

  return (
    <TextButton
      className={className}
      onClick={e => {
        e.preventDefault();
        // copy last price, since options are most likely to have the same price
        const price = fields.value.length === 0 ? 0 : fields.value[fields.value.length - 1].price;
        fields.push(buildNewFormOptionValue({ price }));
      }}
    >
      +&nbsp;
      <FormattedMessage
        id={
          fields.length !== undefined && fields.length > 0
            ? 'menu-option.add-another-option-value'
            : 'menu-option.add-first-option-value'
        }
      />
    </TextButton>
  );
};
